import React from 'react';
import { useTranslation } from 'react-i18next';
import { headingFontBold, vars } from '../../../../../Theme';
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { IAppReduxStore } from '../../../../../redux/store';

export default () => {
    const { t } = useTranslation('translations', { keyPrefix: 'uploadDialog' });
    const currentStep = useSelector((_store: IAppReduxStore) => _store.importDialog.currentStep);

    return (
        <Typography sx={{ ...headingFontBold, fontSize: '16px', color: vars.black, fontWeight: 700 }}>
            {t(`step${currentStep}`)}
        </Typography>
    );
};
